'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024 from "./app.api.-Drug-Requests-Accepted-List-Item$.js";
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$0024anon$002419 from "./app.api.-Drug-Requests-Accepted-List-Item$$anon$19.js";
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$0024anon$002420 from "./app.api.-Drug-Requests-Accepted-List-Item$$anon$20.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$0024anon$002420.$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$20());
    var encodedName = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }))(p));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x106 = annotations.collectFirst__s_PartialFunction__s_Option(new $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$0024anon$002419.$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$19());
  if ((x106 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var altName = x106.s_Some__f_value;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x106)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024.$s_Lapp_api_DrugRequestsAcceptedListItem$__app$api$DrugRequestsAcceptedListItem$Id$$anon$18$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x106);
}
export { $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName($thiz, subtype) {
  return $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, subtype.Lmagnolia1_SealedTrait$Subtype__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(subtype.Lmagnolia1_SealedTrait$Subtype__f_annotations));
}
export { $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName as $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName };
function $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(_$3);
    var that = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18(SchemaMagnoliaDerivation_this$6) {
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__f_SchemaMagnoliaDerivation_this$2 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__f_SchemaMagnoliaDerivation_this$2 = SchemaMagnoliaDerivation_this$6;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 as $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 as $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var name$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18.prototype.split__Lmagnolia1_SealedTrait__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_SealedTrait__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_SealedTrait__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().wrapRefArray__AO__sci_ArraySeq$ofRef(ctx.Lmagnolia1_SealedTrait__f_subtypes);
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12);
      var f = ((s) => {
        var self = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, s.Lmagnolia1_SealedTrait$Subtype__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(s.Lmagnolia1_SealedTrait$Subtype__f_annotations));
        var y = s.typeclass__O();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y);
      });
      if ((this$17 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = this$17.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = this$17.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        var xs = h;
      }
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$IterableToListMap(xs);
      var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var subtypesByName = $x_1.toListMap__s_$less$colon$less__sci_ListMap(this$19.s_$less$colon$less$__f_singleton);
      var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(subtypesByName);
      var subtypes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$20);
      var discriminator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var subtypeSchema = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((t$1) => {
        var ix$tailLocal1 = 0;
        while (true) {
          var $x_2 = ix$tailLocal1;
          var arr = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          if (($x_2 >= arr.u.length)) {
            throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (((("The given value `" + t$1) + "` is not a sub type of `") + ctx.Lmagnolia1_SealedTrait__f_typeInfo) + "`"));
          }
          var arr$1 = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          var n = ix$tailLocal1;
          var sub = arr$1.u[n];
          if ((!sub.isDefinedAt__O__Z(t$1))) {
            ix$tailLocal1 = ((1 + ix$tailLocal1) | 0);
            continue;
          }
          var x0$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$SubtypeValue(sub, t$1);
          var this$24 = subtypesByName.get__O__s_Option($p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, x0$2.Lmagnolia1_SealedTrait$SubtypeValue__f_subtype));
          if (this$24.isEmpty__Z()) {
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          } else {
            var x0$3 = this$24.get__O();
            var value = x0$2.value__O();
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SchemaWithValue(x0$3, value));
          }
        }
      }));
      var baseCoproduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
      matchResult41: {
        var coproduct;
        var x143 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_discriminator;
        if ((x143 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var d = x143.s_Some__f_value;
          var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
          var arr$2 = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          var f$1 = ((s$2) => {
            var schemaName = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, s$2);
            var self$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue.apply__O__O(schemaName);
            var y$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(schemaName);
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$1, y$1);
          });
          var len = arr$2.u.length;
          var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)(len);
          if ((len > 0)) {
            var i = 0;
            if ((arr$2 !== null)) {
              while ((i < len)) {
                var $x_3 = i;
                var x0$4 = arr$2.u[i];
                ys.u[$x_3] = f$1(x0$4);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
              while ((i < len)) {
                var $x_4 = i;
                var x0$5 = arr$2.u[i];
                ys.u[$x_4] = f$1(x0$5);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
              while ((i < len)) {
                var $x_5 = i;
                var x0$6 = arr$2.u[i];
                ys.u[$x_5] = f$1(x0$6);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
              while ((i < len)) {
                var $x_6 = i;
                var t$2 = arr$2.u[i];
                var lo = t$2.RTLong__f_lo;
                var hi = t$2.RTLong__f_hi;
                ys.u[$x_6] = f$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
              while ((i < len)) {
                var $x_7 = i;
                var x0$7 = arr$2.u[i];
                ys.u[$x_7] = f$1(x0$7);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
              while ((i < len)) {
                var $x_8 = i;
                var x0$8 = arr$2.u[i];
                ys.u[$x_8] = f$1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$8));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
              while ((i < len)) {
                var $x_9 = i;
                var x0$9 = arr$2.u[i];
                ys.u[$x_9] = f$1(x0$9);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
              while ((i < len)) {
                var $x_10 = i;
                var x0$10 = arr$2.u[i];
                ys.u[$x_10] = f$1(x0$10);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
              while ((i < len)) {
                var $x_11 = i;
                var x0$11 = arr$2.u[i];
                ys.u[$x_11] = f$1(x0$11);
                i = ((1 + i) | 0);
              }
            } else {
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr$2);
            }
          }
          var this$36 = $x_12.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
          var discriminatorMapping = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this$36);
          var discriminatorName$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(d, d);
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var schemaType$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var name$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var isOptional$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var format$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var deprecated$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var hidden$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
          var discriminatorSchema$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$2, isOptional$1, description$1, default$2, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
          var coproduct = baseCoproduct.addDiscriminatorField__Lsttp_tapir_FieldName__Lsttp_tapir_Schema__sci_Map__Lsttp_tapir_SchemaType$SCoproduct(discriminatorName$1, discriminatorSchema$1, discriminatorMapping);
          break matchResult41;
        }
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x143)) {
          var coproduct = baseCoproduct;
          break matchResult41;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x143);
      }
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var value$1 = $p_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_SealedTrait__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_SealedTrait__f_annotations));
      var name$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var isOptional$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var default$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var deprecated$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var hidden$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
      var schema = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(coproduct, name$3, isOptional$2, description$2, default$3, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18, "app.api.DrugRequestsAcceptedListItem$Id$$anon$18", ({
  Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 as $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$18 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Id$$anon$18.js.map
